import styled from "styled-components";
import TextButton from "./TextButton";
import { ReactComponent as ArrowIcon } from "../../assets/svg/arrow-right-thin.svg";

const TextContainer = styled.span`
  font-size: 14px;
  text-decoration: underline;
`;

const StyledArrow = styled(ArrowIcon)`
  height: 13px;
  width: 13px;
  margin-top: 3px;
  margin-left: 6px;
`;

interface IProps {
  onClick: any;
  children: any;
}

function TextButtonWithArrow({ onClick, children }: IProps) {
  return (
    <TextButton onClick={onClick}>
      <TextContainer>{children}</TextContainer>
      <StyledArrow />
    </TextButton>
  );
}

export default TextButtonWithArrow;
